module.exports = __webpack_public_path__ + "static/media/fulcrum.b5836197.svg";